import Studio from "@/common/components/PlanningStudio/studio";
import { Outlet, useLocation } from "react-router-dom";
import canvasWebSocket from "@/services/websocket-service";
import { useEffect } from "react";

function PlanningStudio() {
  const location = useLocation();
  const isRoot = location.pathname === "/home/planning-templates";

  useEffect(() => {
    if (!canvasWebSocket.getConnectionStatus()) {
      //connect to canvas websocket
      canvasWebSocket.connect();
    }
  }, []);

  return isRoot ? <Studio /> : <Outlet />;
}

export default PlanningStudio;
